export default "__VITE_ASSET__6f2a689f__"